import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  bodyText: {
    lineHeight: '20px',
  },
  alert: {
    marginBottom: theme.spacing(2),
  },
  contactSupport: {
    marginBottom: theme.spacing(3),
  },
}));
